import { render } from "./SiteImpressum.vue?vue&type=template&id=20d143cf&scoped=true"
import script from "./SiteImpressum.vue?vue&type=script&lang=js"
export * from "./SiteImpressum.vue?vue&type=script&lang=js"

import "./SiteImpressum.vue?vue&type=style&index=0&id=20d143cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d143cf"]])

export default __exports__